import { render } from "./MobileBottomBanner.vue?vue&type=template&id=0acc5a60&scoped=true"
import script from "./MobileBottomBanner.vue?vue&type=script&lang=js"
export * from "./MobileBottomBanner.vue?vue&type=script&lang=js"

import "./MobileBottomBanner.vue?vue&type=style&index=0&id=0acc5a60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0acc5a60"]])

export default __exports__